import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	icon: {
		height: 10,
		width: 15,
	},
});
